/*
  Animation observer
*/

// Check if instersectionObserver is supported
function isIntersectionObserver() {
  return !!("IntersectionObserver" in window);
}

// Observe elements
function observable(elements) {
  // Observer configuration
  const config = {
    rootMargin: "-200px 0px -200px 0px",
    threshold: 0,
  };

  // Init intersectionObserver
  const observer = new IntersectionObserver((entries, self) => {
    [].slice.call(entries).forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-active");
        self.unobserve(entry.target);
      }
    });
  }, config);

  // Select items to watch and run the observer
  [].slice.call(elements).forEach((element) => {
    observer.POLL_INTERVAL = 100;
    observer.observe(element);
  });
}

// Fallback function
function notObservable(elements) {
  [].slice.call(elements).forEach((element) => {
    element.classList.add("is-active");
    element.classList.add("force-render");
  });
}

// Observe element or use the fallback
const animation = (el) => {
  const animElementClass = el || ".animation";
  const animElementList = document.querySelectorAll(animElementClass);

  if (isIntersectionObserver()) {
    return observable(animElementList);
  }
  return notObservable(animElementList);
};

export default animation;
